<template>
  <main class="payment-method">
    <p class="payment-method__header">Escolha a forma de pagamento</p>
    <ul class="payment-method__list">
      <template v-for="item in this.paymentMethods">
        <li
          class="payment-method__item"
          v-if="item.show"
          :key="item.label"
          @click="item.onClick(this)"
        >
          <div class="payment-method__textWrapper">
            <p class="payment-method__label">{{ item.label }}</p>
            <p class="payment-method__description">
              {{ item.description }}
            </p>
          </div>
          <ArrowRightSvg />
        </li>
      </template>
    </ul>
    <footer class="payment-method__footer">
      <span class="amount__label">Valor total</span>
      <span class="amount__value">{{ this.toCurrency(totalPrice) }}</span>
    </footer>
    <DrawerBottom
      :open="openDrawer"
      @toggle="openDrawer = !openDrawer"
      @close="openDrawer = false"
      v-if="openDrawer"
      :pixPaymentEnabled="isPixPaymentEnabled"
    >
      <template #content>
        <div class="drawer-content">
          <h3 class="drawer__title">Deseja pagar no guichê?</h3>
          <span class="drawer__description"
            >Ao pagar online você não passa pelo guichê e evita filas.</span
          >
          <VButton text="Mudar forma de pagamento" @click.native="changePaymentMethod()" />
          <VButton
            style="margin-top: 8px"
            variant="tertiary"
            text="Continuar para pagar no guichê"
            @click.native="goToServiceDesk()"
          />
        </div>
      </template>
    </DrawerBottom>
  </main>
</template>

<script>
import { dataLayersMixin } from '@/utils/mixins';
import { mapActions, mapGetters, mapState } from 'vuex';
import store from '@/store';
import DrawerBottom from '@/components/drawerBottom.component.vue';

export default {
  name: 'PaymentChoices',
  components: {
    DrawerBottom,
  },
  mixins: [dataLayersMixin],
  data() {
    return {
      openDrawer: false,
      paymentMethods: [
        {
          label: 'Pagar com Pix',
          description:
            'Pule a etapa de atendimento na recepção e vá direto para a realização do seu exame',
          show: false,
          onClick: () => this.goToPixPayment(),
        },
        {
          label: 'Pagar com Crédito',
          description:
            'Pule a etapa de atendimento na recepção e vá direto para a realização do seu exame',
          show: true,
          onClick: () => this.goToCreditCardPayment(),
        },
        {
          label: 'Pagar no guichê',
          show: true,
          onClick: () => this.openDrawerServiceDesk(),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      exams: ({ currentAdmission }) => currentAdmission.data.medicalOrders[0].exams,
      admission: ({ currentAdmission }) => currentAdmission.data,
    }),
    ...mapGetters({
      haveScheduledExams: 'haveScheduledExams',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isPixPaymentEnabled: 'isPixPaymentEnabled',
    }),
    totalPrice() {
      return this.exams.reduce((total, exam) => total + exam.price, 0);
    },
  },
  mounted() {
    if (this.isPixPaymentEnabled) {
      this.paymentMethods[0].show = this.isPixPaymentEnabled;
    }
  },
  created() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Forma de pagamento',
    });
  },
  methods: {
    ...mapActions({
      checkAndSetT2Flow: 'checkAndSetT2Flow',
      updateFlowSteps: 'global/updateFlowSteps',
      setAdmissionNotElegible: 'setAdmissionNotElegible',
    }),
    goToCreditCardPayment() {
      store.commit('SET_ADMISSION_PAYMENT_METHOD', 'Crédito');
      this.$router.push({ name: 'credit-card-payment', params: { amount: this.totalPrice } });
    },
    goToPixPayment() {
      store.commit('SET_ADMISSION_PAYMENT_METHOD', 'Pix');
      this.$router.push({ name: 'pix-payment' });
    },
    changePaymentMethod() {
      store.commit('SET_ADMISSION_PAYMENT_METHOD', 'Desistiu Guichê');
      this.toggleDrawer();
    },
    openDrawerServiceDesk() {
      store.commit('SET_ADMISSION_PAYMENT_METHOD', 'Guichê');
      this.toggleDrawer();
    },
    toggleDrawer() {
      this.openDrawer = !this.openDrawer;

      if (this.openDrawer) {
        this.mostCommonPagesAnalytics({
          eventType: 'funnel_step',
          currentStep: 'Deseja pagar no guichê?',
        });
      }
    },
    async goToServiceDesk() {
      await this.setAdmissionNotElegible();
      /* eslint-disable */

      this.$emit('payment-without-card');

      if (this.isVaccineFlow) return this.goNextStep('queue_end_flow');
      /* eslint-enable */
      await this.goNextStep('end_flow_success');
    },
    toCurrency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-method {
  &__header {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    line-height: 24px;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    padding: 19px 21px;
    font-weight: 700;
    cursor: pointer;
    font-size: 16px;
    line-height: 19px;
    transition: 0.5s background;
    color: #343a40;

    &:first-child {
      margin-top: 24px;
    }

    &:not(:last-child) {
      margin-bottom: 24px;
    }

    &:hover {
      background: #f5f5f5;
    }

    & svg {
      width: 11px;
      height: 18px;
    }
  }
  &__textWrapper {
    display: flex;
    flex-direction: column;
    max-width: 80%;
    text-align: left;
    gap: 8px;
  }
  &__label {
    font-size: 16px;
    font-weight: 700;
  }
  &__description {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
  }
  &__footer {
    bottom: 0;
    padding: 16px 40px 24px 16px;
    position: fixed;
    display: flex;
    justify-content: space-between;
    width: inherit;
  }
}
.amount {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__label {
    color: #363636;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }

  &__value {
    color: var(--color-grey-8);
    font-size: var(--font-size-3);
    font-weight: var(--font-weight-medium);
  }
}

.drawer__title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 24px;
}
.drawer__description {
  font-weight: 300;
  font-size: 16px;
  margin: 24px 0;
  color: #797c86;
  display: block;
}
</style>
